/* eslint-disable no-param-reassign */

import axios from 'axios/index'

import { firebase } from '../firebase'

import store from '../stores'

const FIREBASE_BE = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
})

const requestInterceptor = {
  success: (config) => {
    if (firebase.auth().currentUser) {
      return firebase.auth().currentUser.getIdToken()
        .then(token => {
          store.dispatch('startApiLoading')
          config.headers.Authorization = `Bearer ${token}`
          return config
        })
        .catch(error => {
          console.error('[REQ INTERCEPT] error requesting FB token', error)
          return Promise.reject(error)
        })
    }
    return config

  },
  error: (error) => {
    console.log('[REQ INTERCEPT] Request error', error)
    return Promise.reject(error)
  },
}

const responseInterceptor = {
  success: (response) => {
    store.dispatch('stopApiLoading')
    return response
  },
  error: (error) => {
    store.dispatch('stopApiLoading')
    // In all cases we want the "response" object here
    return Promise.reject(error.response)
  }
}

FIREBASE_BE.interceptors.request.use(requestInterceptor.success, requestInterceptor.error)
FIREBASE_BE.interceptors.response.use(responseInterceptor.success, responseInterceptor.error)

export default FIREBASE_BE
